module.exports = __webpack_public_path__ + "static/media/caregiver-jobma.f1b9d898.png";